import { Schema as S } from "effect"

export namespace RedirectTo {
  export const Key = "redirectTo" as const

  export const Schema = S.Struct({ [Key]: S.optional(S.String) })
}
